import Button from '@/components/Button';
import Drawer from '@/components/Drawer';
import { FiBookmark, FiMenu, MdOutlineRocketLaunch, PiSlackLogo } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import usePlatformNav from '@/hooks/usePlatformNav.js';
import { useState } from 'react';
import Link from '@/components/Link.jsx';
import Stack from '@/components/v3/Stack.jsx';
import PlatformCompanySelect from './PlatformCompanySelect.jsx';
import { buildWebsiteUrl } from '@shared/utils/websiteBaseUrl.js';

const PlatformMobileNav = () => {
  const items = usePlatformNav();
  const activeRoute = items?.find((item) => item.active);
  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <>
      <Button icon={FiMenu} className="btn-mobile-nav mobile-only" onClick={() => setShowDrawer(true)}>
        {activeRoute?.label}
      </Button>

      <Drawer show={showDrawer} onHide={() => setShowDrawer(false)} direction="left" portal className="comp-platform-mobile-drawer">
        <div className="top-content">
          <div className="header">
            <div className="logo-and-company-name">
              <Link to={'/'}>
                <Stack className={'logo-wrapper'} data-title={'Home'}>
                  <img className={'logo'} src={'/images/logo-mark.svg'} alt={'Logo'} />
                </Stack>
              </Link>
              <PlatformCompanySelect active={true} />
            </div>
            <Button key={items?.[0].label} icon={items?.[0].icon} className={`full-width ${items?.[0].active ? 'filled' : 'ghost medium'}`} size={'xl'} onClick={() => setShowDrawer(false)} route={items?.[0].route}>
              {items?.[0].label}
              {items?.[0].rightIcon ? <IconV2 className={'right-icon'} icon={items?.[0].rightIcon} title={items?.[0].label} /> : ''}
            </Button>
          </div>
          <div className="items">
            {items.slice(1).map((item) => (
              <Button key={item.label} icon={item.icon} className={`full-width ${item.active ? 'filled' : 'ghost medium'}`} size={'xl'} onClick={() => setShowDrawer(false)} route={item.route}>
                {item.label}
                {item.rightIcon ? <IconV2 className={'right-icon'} icon={item.rightIcon} title={item.label} /> : ''}
              </Button>
            ))}
          </div>
        </div>
        <div className="footer">
          <Button icon={PiSlackLogo} className={'full-width ghost medium'} size={'xl'} route={'https://join.slack.com/t/mindcloudusers/shared_invite/zt-2s88hy60h-MFNJeWSzYtrlMFUl8MN1zg'} target={'_blank'}>
            Slack Community
          </Button>
          <Button icon={MdOutlineRocketLaunch} className={'full-width ghost medium'} size={'xl'} route={buildWebsiteUrl('/changelog')} target={'_blank'}>
            Changelog
          </Button>
          <Button icon={FiBookmark} className={'full-width ghost medium'} size={'xl'} route={'https://mindcloud.co/docs'} target={'_blank'}>
            Docs
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default PlatformMobileNav;
